import { useMemo } from "react";
import { range } from "@common/helpers/collections";
import { formatISO, parseISO } from "date-fns";
import { useConstant } from "@hooks/useConstant";
import { useEntities } from "@hooks/useEntities";

export function useAvailableYears() {
    const entities = useEntities();
    const today = useConstant(() => new Date());
    return useMemo(() => {
        const currentDateString = formatISO(today, {
            representation: "date",
        });

        const earliestBookkeepingStartString = entities.reduce(
            (earliest, entity) =>
                entity.bookkeepingStartDate < earliest
                    ? entity.bookkeepingStartDate
                    : earliest,
            currentDateString,
        );

        const earliestBookkeepingStart = parseISO(
            earliestBookkeepingStartString,
        );
        const earliestYear = earliestBookkeepingStart.getUTCFullYear();
        const currentYear = today.getFullYear();

        return range(earliestYear, currentYear + 1).reverse();
    }, [entities, today]);
}
